import React from "react";

/**
 * Suit une media query en JS.
 *
 * Utile pour ne *monter* qu'une seule variante d'une liste, là où les
 * utilitaires `d-none` / `d-md-block` de Bootstrap se contentent de masquer
 * en CSS : les nœuds masqués existent quand même dans le DOM et sont
 * réconciliés par React à chaque rendu.
 */
const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = React.useState<boolean>(
    () => window.matchMedia(query).matches
  );

  React.useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);

    setMatches(mediaQueryList.matches);
    mediaQueryList.addEventListener("change", onChange);

    return () => mediaQueryList.removeEventListener("change", onChange);
  }, [query]);

  return matches;
};

export default useMediaQuery;